import React, { useState } from 'react';
import CustomerDetail from 'containers/Common/Customer/customerDetail';
import ChiTietHopDongContainer from 'containers/Common/QuanLyChoVay/ChiTietHopDongContainerV2';
import ChiTietHopDongApi from "service/chiTietHopDongApi";
import { ModalChiTietHopDong as ModalChiTietNhanVay } from "../../../NhanVay/ChiTietHopDong/ModalChiTietHopDong";

export const BtnChiTietKhachHang = ({ item }) => {
    const [show, setShow] = useState(false);
    const [showChoVay, setShowChoVay] = useState(false);
    const [dataChoVay, setDataChoVay] = useState(null);
    const [showNhanVay, setShowNhanVay] = useState(false);
    const [dataNhanVay, setDataNhanVay] = useState(null);

    const handleOpenHopDong = (itemGiaoDich) => () => {
        if (itemGiaoDich.NhanVayId && itemGiaoDich.NhanVayId > 0) {
            setDataNhanVay(itemGiaoDich);
            setShowNhanVay(true);
            setShow(false); 
            return;
        }
        const choVayId = itemGiaoDich.ChoVayId || itemGiaoDich.ChoVayID;
        if (choVayId) {
            ChiTietHopDongApi.getChiTietHopDong1(choVayId).then((res) => {
                if (res && res.data) {
                    setDataChoVay(res.data);
                    setShowChoVay(true);
                    setShow(false);
                }
            });
        }
    };

    return (
        <>
            <a href="#!" onClick={() => setShow(true)} className="blue btn-link">
                {item.TenKhachHang}
            </a>
            {show && (
                <CustomerDetail
                    show={show}
                    onHide={() => setShow(false)}
                    data={{ CustomerID: item.CustomerID }}
                    showChiTietHopDong={handleOpenHopDong}
                />
            )}
            {showChoVay && dataChoVay && (
                <ChiTietHopDongContainer
                    show={showChoVay}
                    onHide={() => {
                        setShowChoVay(false);
                        setShow(true);
                    }}
                    data={dataChoVay}
                    dbName={item.DBName}
                    setModalTaiSan={() => {}}
                />
            )}
            {showNhanVay && (
                <ModalChiTietNhanVay
                    show={showNhanVay}
                    onHide={() => {
                        setShowNhanVay(false);
                        setShow(true);
                    }}
                    nhanvayId={dataNhanVay?.NhanVayId}
                    item={dataNhanVay}
                />
            )}
        </>
    );
};